export const caseStatusMapper = {
  dispute: 100,
  preArbitration: 200,
  arbitration: 300,
};
